import styled from "styled-components";
import {BackPermaFilter, BackTableField} from "../../../features/schemaManageSlice";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import hljs from "highlight.js/lib/core";
import React, {useState} from "react";
import {headerTypesIcons, schemas} from "../../../config";
import {Field, FIELD_TYPE_INFO} from "../../../Types";
import {FontAwesomeTypeIcon} from "../../misc/TypeIcon";
import {getReadableTextColor} from "../../filters/FilterMultiMapValue";
import {faCheck, faEdit, faQuestion, faTriangleExclamation, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {SqlQuery} from "./BackTableFieldViewTable";
import EditOuterField from "./edit/EditOuterField";
import EditPermaFilter from "./edit/EditPermaFilter";

interface BackTableFieldPropsI {
    tableName: string,
    filterKey: string,
    filter: BackPermaFilter,
    index: number,
}

type FieldItemTypeU = "static" | "ethereal" | "other";

type FieldItemViewPropsI = {
    filterKey: string,
    filter: BackPermaFilter,
    index: number,
    type: FieldItemTypeU,
    editable?: boolean,
};

export default function BackTablePermaFilterViewTable({tableName, filters}: {
    tableName: string,
    filters: Record<string, BackPermaFilter>
}) {

    return <Container>
        <table>
            <thead>
            <tr>
                <th>Ключ</th>
                <th>SQL</th>
                <th>Залежать</th>
                <th>#</th>
            </tr>
            </thead>
            <tbody>
            {Object.entries(filters).map(([key, filter], i) =>
                <BackTablePermaFilterView tableName={tableName} key={key} index={i} filterKey={key} filter={filter}/>)}
            </tbody>
        </table>

    </Container>
}

function BackTablePermaFilterView({
                               tableName,
                               filterKey,
                               filter,
                               index,
                           }: BackTableFieldPropsI) {

    const staticTable = useAppSelector(state => state.schemaManage.back.staticTables[tableName]);
    const staticFilter = staticTable !== null && staticTable.permaFilter[filterKey]
    const etherealTable = useAppSelector(state => state.schemaManage.back.etherealTables[tableName]);
    const etherealPermaFilter = etherealTable !== null && etherealTable.permaFilter[filterKey]
    const mode = useAppSelector(state => state.schemaManage.back.mode);
    const project = useAppSelector(state => state.project.name);

    return <>
        {mode === "edit" && staticFilter &&
            <PermaFilterItemView filter={staticFilter} type={"static"} filterKey={filterKey} index={index}/>}
        {mode === "edit" && etherealPermaFilter &&
            <PermaFilterItemView editable filter={etherealPermaFilter} type={"ethereal"} filterKey={filterKey} index={index}/>}
        {mode === "view" &&
            <PermaFilterItemView filter={filter} type={"other"} filterKey={filterKey} index={index}/>}
    </>
}

function PermaFilterItemView({
                          index,
                          filterKey,
                          type,
                          editable = false,
                          filter
                      }: FieldItemViewPropsI) {

    const [isEditing, setIsEditing] = useState(false)
    const closeEditing = () => setIsEditing(false);

    return <>
        <tr className={"title"}>
            <td className={'key'}>
                <div className="cont">
                    <span>{filterKey}</span>
                    {editable && <button className={'edit-backtable-field btn-cmn'} onClick={() => setIsEditing(true)}>
                        <FontAwesomeIcon size={"lg"} icon={faEdit} className={'fa-secondary-color-text'}/>
                    </button>}
                </div>
                {isEditing &&
                    <EditPermaFilter closeEditing={closeEditing} filter={filter} filterKey={filterKey}/>}
            </td>
            <td className="sql">
                <div className="sql-cont">
                    <SqlQuery sqlQuery={filter.sql}/>
                </div>
            </td>
            <td className="depends">
                <div className="dep">
                    {filter.depends.map((d, i) => <span key={i} className="d">
                        {d}
                    </span>)}
                </div>
            </td>
            <td className={"index"}>{type === "static" && <i>STATIC |&nbsp;</i>}{index + 1}</td>
        </tr>
    </>
}


const Container = styled.div`
    //display: flex;
    //flex-direction: column;
    //gap: .5rem;
    width: 100%;
    //max-width: 100%;
    padding: .4rem;
    border-radius: .2rem;
    background-color: var(--table-header-bg-color);
    //border-collapse: separate;
    overflow-x: auto;
    
    table {
        table-layout: auto;
        width: 100%;
        border: 1px solid var(--table-border-color);

        th, td {
            vertical-align: middle;
            padding: .4rem .2rem;
            line-height: 1.2;
            border-bottom: 2px solid var(--table-border-color);
            border-right: 2px solid var(--table-border-color);
            border-left: 2px solid var(--table-border-color);
            border-top: 2px solid var(--table-border-color);

        }
        
        th {
            text-align: center;
            white-space: nowrap;
        }
    }

    tbody {
        max-width: 100%;
        overflow-x: auto;

        & > tr {
            max-width: 100%;
            width: 100%;
            overflow-x: auto;
        }

    }

    .present {
        text-align: center;
    }

    .content {
        width: 100%;
    }

    .depends {
        white-space: nowrap;
        width: 1%;

        .dep {
            display: inline-flex;
            gap: .5rem;

            .d {
                padding: .1rem;
                border-radius: .1rem;
                background-color: black;
                color: white;
            }
        }
    }


    .title {

        line-height: 1;

        .icon {
            //width: 1.25rem;
            //display: flex;
            //align-items: center;
            //justify-content: center;
            width: 1%;
            text-align: center;
        }

      .key {
        width: 1%;
        text-align: left;
        padding-right: .4rem;
        padding-left: .4rem;
        white-space: nowrap;

        .cont {
          display: inline-flex;
          gap: .5rem;
          align-items: center;
          justify-content: space-between;
          width: 100%;

          & button {
            padding: .2rem;
          }
        }
      }

        .front-type {
            padding: .2rem .4rem;
            border-radius: .2rem;
            //width: fit-content;
            width: 100%;
            white-space: nowrap;
            display: inline-block;
            //height: 3rem;
            //width: 100%;
        }

        .missing {
            //background-color: #62615c;
            //color: yellow;
            //padding: .2rem .4rem;
            //border-radius: .2rem;
        }
    }

    .index {
        min-width: 30px;
        width: 1%;
        text-align: center;
        white-space: nowrap;
    }

    .row {
        overflow-x: auto;
    }

    .sql {
        //display: block;
        overflow-x: auto;
        max-width: 1px;

        white-space: nowrap;

        .sql-cont {
            max-width: 100%;
            //max-width: 500px;

            word-break: break-word;
            overflow-x: auto;
        }
    }


`;
